module.exports = __webpack_public_path__ + "static/media/icon_payment_pending.e25644d3.svg";